// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styles from "./AttestDocumentModal.module.scss";
import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import Radio from "components/Radio/Radio";

import {
    attestDocumentAction
} from "store/actions/Actions";

const AddTaskModal = props => {
    const [isUnderstood, setUnderstood] = useState(false);
    const { attestDocumentAction, attestationId } = props;

    const attestDocument = () => {
        attestDocumentAction({
            id: attestationId,
            understood: isUnderstood,
        });
        props.setShowModal(false);
    }

    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
            
        >
            <div>
                <p className={styles["modal-heading"]}>Attest document</p>

                <div className={styles["modal-content"]}>
                    <div>
                        <div className={styles.question}>
                        I hereby attest and acknowledge that I have read and understood the contents of this Policy, Procedure Manual and training. Through my attestation, I hereby confirm that I am bound by organization’s policies and procedures, and will perform my job duties accordingly. I understand that if I violate any organization security policy or procedure, I am subject to disciplinary action, up to and including termination of my employment.
<br/><br/>I hereby acknowledge and agree that this attestation is the equivalent of a physical or e-signature
                        </div>

                        <div>
                            <Radio
                                checked={isUnderstood === true}
                                labelText="I completely read and understand the document"
                                onChange={() => {
                                    setUnderstood(true);
                                }}
                                value={true}
                            />
                            <Radio
                                checked={isUnderstood === false}
                                labelText="I did NOT READ the document (it still requires attestation and understanding)"
                                onChange={() => {
                                    setUnderstood(false);
                                }}
                                value={false}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CANCEL"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                    <Button
                        text="SUBMIT"
                        className={styles.create}
                        onClick={() => attestDocument()}
                    />
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    attestDocumentAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddTaskModal);
